var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import Link from "@irati/ui/src/Link";
import { MarginLeftPara } from "../shared";
var StyledLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:hover, &:focus {\n    text-decoration: none;\n  }\n"], ["\n  &:hover, &:focus {\n    text-decoration: none;\n  }\n"])));
var HelpEmail = /** @class */ (function (_super) {
    __extends(HelpEmail, _super);
    function HelpEmail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HelpEmail.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        return (React.createElement(StyledLink, { uppercase: false, href: formatMessage({ id: "medical.landing.contactCard.email.mailto" }) },
            React.createElement(MarginLeftPara, { blue: true, large: true },
                React.createElement(FormattedMessage, { id: "medical.landing.contactCard.email.text" }))));
    };
    return HelpEmail;
}(PureComponent));
export default injectIntl(HelpEmail);
var templateObject_1;
